const statisticsEn = {
    "user_statistics": "User Statistics",
    "menu_item_clicks": "Menu Item Clicks",
    "statistics": "Statistics",
    "user_traffic": "User Traffic",
    "last_7_days": "Last 7 Days",
    "last_30_days": "Last 30 Days",
    "menu_item": "Menu Item",
    "click_count": "Click Count",
    "error_fetching_user_statistics": "Error fetching user statistics.",
    "error_fetching_menu_item_statistics": "Error fetching menu item statistics.",
    "statistics_feature_not_available": "The statistics feature is only available in the PRO plan. Please upgrade your subscription to access this feature.",
    "change_subscription_plan": "Change Subscription Plan",
    "permission_denied": "Permission Denied",
    "error_fetching_rating_statistics": "Error fetching rating statistics.",
    "menu_item_ratings": "Menu Item Ratings",
    "likes": "likes",
    "dislikes": "dislikes",
    "rating_trends_last_7_days": "Rating trends (last 7 days)",
    "rating_trends_last_30_days": "Rating trends (last 30 days)",
};

export default statisticsEn;